import store from '../store/index.js'
import axios from'axios'
import pinyin from "pinyin";
import { MessageBox } from "element-ui";

//js方法格式化数字，加入千分符
export function fmoney(s) {
  //console.log('format:' + s);
  if (s == '*') {
    return s;
  }

  var n = 2;
  n = n >= 0 && n <= 20 ? n : 2;
  s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
  var l = s
    .split(".")[0]
    .split("")
    .reverse(),
    r = s.split(".")[1];
  r = r == null ? "" : "." + r;
  var t = "";
  //console.log(l)
  if (l[l.length - 1] === '-') { //负数不需要分隔号,

    for (var i = 0; i < l.length; i++) {
      if (l[i] === '-') {
        t += l[i] + ""
        continue
      }
      //不是数组的倒数第二个元素才加"," ["0", "4", "5", "-"]
      t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length - 1 ? "," : "");

      //i + 1 != l.length会变成-,540.00,因为在5时元素位置2+1为3非数组长度
      //t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? "," : "");
    }
  } else {
    for (var i = 0; i < l.length; i++) {
      t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? "," : "");
    }
  }
  return (
    t
    .split("")
    .reverse()
    .join("") + r
  );


}
//排序规则
export function sortby(name, minor, sort) {
  return function(o, p) {
    var a, b;
    if (o && p && typeof o === 'object' && typeof p === 'object') {
      a = o[name];
      b = p[name];
      if (a === b) {
        return typeof minor === 'function' ? minor(o, p) : 0;
      }
      if (typeof a === typeof b) {
        a = parseFloat(a.toString().replace(/,/g, ''));
        b = parseFloat(b.toString().replace(/,/g, ''));
        if (sort == 'ascending') {
          return a < b ? -1 : 1;
        } else if (sort == 'descending') {
          return a < b ? 1 : -1;
        }

      }
      if (sort == 'ascending') {
        return typeof a < typeof b ? -1 : 1;
      } else if (sort == 'descending') {
        return typeof a < typeof b ? 1 : -1;
      }

    } else {
      throw ("error");
    }
  }
}
export function tableHeadClass() {
  let classname=localStorage.getItem('classname') ? localStorage.getItem('classname') : 'common';
  

  let headClass='text-align: center;background: url(/static/images/th-bg.png) repeat-x #f4f5f6; background-size: auto 28px; color: #000000; font-size: 12px; font-weight: bold;border-bottom: 1px solid #ececec;';
  
  headClass='text-align: center;background-color: #3fc8dd; color: #FFFFFF; font-size: 12px; font-weight: normal;border-bottom: 1px solid #ececec;';
  return headClass;
}
export async function GetBiZhongMoRenZhi(){
  let canshu=GetXiTongCanShu('YWDJ_BWBMRFS','参数代码'); //业务单据本位币默认方式
  //console.log('canshu:',canshu)
  let cs=1;

  try{
    cs=parseInt(canshu.参数值);
  }catch(e){
    //TODO handle the exception
  }
  let returnData={};

  returnData.业务单位本位币默认方式=cs;
  returnData.本位币名称='';
  returnData.汇率='';

  if(cs>0){
    const {data:res} = await axios.get("/Handler/Base/JiChuZiLiao/HuoBiZiLiao.ashx?mode=list")

    let bwbData=res.data.find(item=>item.是否本位币=='1');

    returnData.本位币名称=bwbData.货币名称;
    returnData.汇率=bwbData.汇率;
  }

  return returnData;
}
/*
计算弹出窗口位置
event         鼠标点击事件
dialogWidth   弹出窗口宽度
dialogHeight  弹出窗口高度
top           指定弹出窗口top值
left          指定弹出窗口left值
type          弹出窗口位置计算类型，1：屏幕居中，2：根据鼠标点击位置计算，3：手动指定窗口位置
*/
export function WeiZhi(event, dialogWidth, dialogHeight, top, left, type) {
  let screenWidth = document.body.clientWidth;
  let screenHeight = document.body.clientHeight;
  let h = document.body.offsetHeight;

  //console.log('screenHeight:' + screenHeight + '，screenWidth:' + screenWidth + '，screenHeight:' + h,event);
  //console.log('clientX:' + event.clientX + ',clientY:' + event.clientY);

  let t = 0;
  let l = 0;

  if (type == 1) {
    t = (screenHeight - dialogHeight) / 2;
    l = (screenWidth - dialogWidth) / 2;
  } else if (type == 2) {
    t = event.clientY - dialogHeight;
    l = event.clientX - dialogWidth / 2;

    if (event.clientY < dialogHeight) {
      t = event.clientY + 27;
    }
    if (event.clientX < dialogWidth) {
      l = dialogWidth - event.clientX;
    }
    if (t + dialogHeight > screenHeight && screenHeight > 0) {
      t = t - (t + dialogHeight - screenHeight)
    }
    if (l + dialogWidth > screenWidth && screenWidth > 0) {
      l = l - (l + dialogWidth - screenWidth);
    }
  } else if (type == 3) {
    t = top;
    l = left;
  }

  if (t < 0) {
    t = 50;
  }
  if (l < 0) {
    l = 50;
  }

  return {
    left: l,
    top: t
  };
}
/*
计算并设置弹出窗口位置
dialogID      弹出对话框ID
event         鼠标点击事件
dialogWidth   弹出窗口宽度
dialogHeight  弹出窗口高度
type          弹出窗口位置计算类型，1：屏幕居中，2：根据鼠标点击位置计算，3：手动指定窗口位置，可省略，默认为1
top           指定弹出窗口top值，type为3时有效，可省略，默认为50
left          指定弹出窗口left值，type为3时有效，可省略，默认为50
返回值：{left: l,top: t}
注：只能省略最后面的参数，如省略最后一个参数，或省略最后二个参数，或省略最后三个参数，不能省略中间的参数
*/
export function SetWeiZhi(dialogID,event, dialogWidth, dialogHeight, type=1, top=50, left=50) {
  let screenWidth = document.body.clientWidth;
  let screenHeight = document.body.clientHeight;
  let h = document.body.offsetHeight;

  //console.log(dialogID,dialogWidth,dialogHeight,type,top,left);
  //console.log('screenHeight:' + screenHeight + '，screenWidth:' + screenWidth + '，screenHeight:' + h,event);
  //console.log('clientX:' + event.clientX + ',clientY:' + event.clientY);

  let t = 0;
  let l = 0;

  if (type == 1) {
    t = (screenHeight - dialogHeight) / 2;
    l = (screenWidth - dialogWidth) / 2;
  } else if (type == 2) {
    t = event.clientY - dialogHeight;
    l = event.clientX - dialogWidth / 2;

    if (event.clientY < dialogHeight) {
      t = event.clientY + 27;
    }
    if (event.clientX < dialogWidth) {
      l = dialogWidth - event.clientX;
    }
    if (t + dialogHeight > screenHeight && screenHeight > 0) {
      t = t - (t + dialogHeight - screenHeight)
    }
    if (l + dialogWidth > screenWidth && screenWidth > 0) {
      l = l - (l + dialogWidth - screenWidth);
    }
  } else if (type == 3) {
    t = top;
    l = left;
  }

  if (t < 0) {
    t = 50;
  }
  if (l < 0) {
    l = 50;
  }

  setTimeout(()=>{
    let dragDom = document.querySelector('#' + dialogID + ' .el-dialog');

    if(!dragDom)
    {
      dragDom=document.querySelector('.el-dialog');
    }
    if(dragDom)
    {
      dragDom.style.marginTop = '0px';
      dragDom.style.left = l + 'px';
      dragDom.style.top = t + 'px';
      dragDom.style.width = dialogWidth + 'px';
    }

  },50);

  return {
    left: l,
    top: t
  };
}

/**
 *  将平行结果转换成树形结构，父编号不可为空，如果为最高，则可以设置root等字样
 *  如果有排序字段，将排序完成后返回
 *  如：data:[{id:'1', parentId:'root', name:'test'}, {id:'2', parentId:'1', name:'test1'},{id:'3', parentId:'1', name:'test2'}]
 *     format:{id:'id', root:'root', 'pid':'parentId', child:'children'}
 *  解析后的数据形式为:
 *  [{id:'1','parentId':'root',name:'test', children:[{id:'2',parentId:'1',name:'test1'},{id:'3',parentId:'1',name:'test2'}]}]
 *  @param data   -- 需要转换的数据
 *  @param format -- 转换格式 {id:'', root:'', pid:'', child:'', sort:{field:'', direct:1}}
 *  @return {*} 转换后的数据
 */
export function TreeFormat(data, format) {
  console.log(format);
  //如果data，没有数据，则将data原样返回
  if (!data || data.length <= 0) return data;
  var map = maps(data, format);
  //再遍历原数据进行树形填充
  for (var i = 0, len = data.length; i < len; i++) {
    var d = data[i];
    if (map.dm[d[format.pid]]) {
      map.dm[d[format.pid]][format.child].push(d);
    }
  }
  //最后将root排序后返回
  sort(map.root, format);
  return map.root;
}
/**
 * 平行数据映射为map
 * @param data     -- 平行数据
 * @param format   -- tree格式化信息
 * @return {{d, root}}  -- 返回数据和根数据map
 */
function maps(data, format) {
  var dataMap = {}; //全数据映射
  var root = []; //根
  for (var i = 0, len = data.length; i < len; i++) {
    var d = data[i];
    //初始化child字段,如果不想要这里初始化也可以在树形填充出进行判断初始化
    d[format.child] = [];
    dataMap[d[format.id]] = d;
    if (data[i][format.pid] === format.root) { //将root记录到root数组
      root.push(d);
    }
  }
  return {
    dm: dataMap,
    root: root
  };
}
/**
 * 进行排序  format.sort格式为sort:{field:'', direct:1},其中direct=1为正序，direct=-1为逆序
 * @param result  -- 结果集
 * @param format  -- 格式化
 */
function sort(result, format) {
  if (!format.sort) return; //没有排序配置则不进行排序
  result.sort(function(a, b) {
    var as = a[format.sort.field];
    var bs = b[format.sort.field];
    return (as - bs) * format.sort.direct;
  });
  //如果result中有child，则继续进行排序
  for (var i = 0, len = result.length; i < len; i++) {
    if (result[i][format.child].length > 0) {
      sort(result[i][format.child], format);
    }
  }
}
//将数据转化为树形表格
export function translateDataToTreeTable(data) {
  let parents = data.filter(
    value => value.ParentID == "0" || value.ParentID == null
  );
  let children = data.filter(
    value => value.ParentID !== "0" && value.ParentID != null
  );
  //console.log(children);
  let translator = (parents, children) => {
    // 遍历父节点数据
    parents.forEach(parent => {
      // 遍历子节点数据
      children.forEach((current, index) => {
        // 当父节点对应的一个子节点相等时
        if (current.ParentID === parent.ID) {
          //对子节点数据进行深复制,防止当temp改变而改变子节点
          let temp = JSON.parse(JSON.stringify(children));
          // 让当前子节点从temp中移除，temp作为新的子节点数据
          temp.splice(index, 1);
          // 让当前子节点作为唯一的父节点，去递归查找其对应的子节点
          translator([current], temp);
          // 把找到子节点放入父节点的children属性中
          typeof parent.children !== "undefined" ?
            parent.children.push(current) :
            (parent.children = [current]);
        }
      });

    });
  };
  // 调用转换方法
  translator(parents, children);
  //返回
  return parents;
}
/**
 * 将数据转化为树形，可以在tree控件显示，添加label和value属性
 * @param labelColumn label对应的字段名
 * @param valueColumn value对应的字段名
 * @param expanded 节点展开状态
 **/
export function translateDataToTree(data, labelColumn, valueColumn,expanded) {
  if(expanded!=false)
  {
    expanded=true;
  }
  let parents = data.filter(
    value => value.ParentID == "0" || value.ParentID == 0 || value.ParentID == null
  );
  let children = data.filter(
    value => value.ParentID !== "0" && value.ParentID !== 0 && value.ParentID != null
  );
  //console.log(parents,children);
  let translator = (parents, children) => {
    // 遍历父节点数据
    parents.forEach(parent => {
      // 遍历子节点数据
      children.forEach((current, index) => {
        // 当父节点对应的一个子节点相等时
        if (current.ParentID === parent.ID) {
          //对子节点数据进行深复制,防止当temp改变而改变子节点
          let temp = JSON.parse(JSON.stringify(children));
          // 让当前子节点从temp中移除，temp作为新的子节点数据
          temp.splice(index, 1);
          // 让当前子节点作为唯一的父节点，去递归查找其对应的子节点
          translator([current], temp);
          // 把找到子节点放入父节点的children属性中
          current.label = current[labelColumn]; //为节点添加label属性
          current.value = current[valueColumn]; //为节点添加value属性
          current.expanded=expanded;  //展开状态
          typeof parent.children !== "undefined" ?
            parent.children.push(current) :
            (parent.children = [current]);
        }
      });
      parent.label = parent[labelColumn]; //为节点添加label属性
      parent.value = parent[valueColumn]; //为节点添加value属性
      parent.expanded=expanded;
    });
  };
  // 调用转换方法
  translator(parents, children);

  //console.log(parents);
  dataSort(parents); //根据顺序排序

  return parents;
}
/**
 * 对数组进行排序，可以是树状数据，也可以是非树状数据。树状数据下级数据key为children
 * @param {Array} data 待排序数据
 */
export function dataSort(data) {
  data.sort((a, b) => {
    if (a.children) dataSort(a.children);
    if (b.children) dataSort(b.children);
    return parseInt(a.顺序) - parseInt(b.顺序);
  });
}

/**
 * 对数组进行排序，
 * @param {Array} data 待排序数据
 * @param {string} key 数据中的字段名
 */
export function sortBykey(data, key) {
 	return data.sort(function (a, b) {
    	let x = parseInt(a[key])
    	let y = parseInt(b[key])
    	return ((x < y) ? -1 : (x > y) ? 1 : 0)
  	})
}

/**
 * 为数据添加label和value属性
 * @param {Array} data 待转换的数据
 * @param {String} labelColumn   label对应的字段名
 * @param {String} valueColumn   value对应的字段名
 */
export function FormatSelectData(data, labelColumn, valueColumn) {
  let returnData = [];

  data.forEach((item, index, data) => {
    item.label = item[labelColumn];
    item.value = item[valueColumn];

    returnData.push(item);
  });

  return returnData;
}
/**
 * 在一个Tree数组中查询匹配AutoID的行，如果要匹配其它字段，将AutoID值为-2
 * @param {Array} data    待查找的数组
 * @param {String} AutoID 待查找的AutoID值，AutoID为-2时根据key和value查找匹配的行
 * @param {String} key    待查找的key，AutoID为-2时有效
 * @param {String} value  待查找的key对应的值，AutoID为-2时有效
 */
export function locateTreeData(data, AutoID, key, value) {
  // jty 20200717
  // 找一个tree数组中匹配AutoID值的行
  // 如果AutoID 为-2 那么用后两个参数匹配,
  let returnData = {};
  if (data) {


    for (let i = 0; i < data.length; i++) {
      let item = data[i];
      if (AutoID != -2) {
        if (item.AutoID == AutoID) {
          returnData = item;
        } else if (item.children) {
          let aa = locateTreeData(item.children, AutoID);
          if (JSON.stringify(returnData) === '{}')
            returnData = aa;
        }
      } else {
        if (item[key] == value) {
          returnData = item;
        } else if (item.children) {
          let aa = locateTreeData(item.children, AutoID, key, value);
          if (JSON.stringify(returnData) === '{}')
            returnData = aa;
        }
      }
    }
  }
  return returnData;
}
export function find(data, sx, type) {
  let resrow = {};
  let flag = false;
  for (let i = 0; i < data.length; i++) {
    let arow = data[i];
    if (type == 'prev') {
      if (arow.顺序 == sx) {
        break;
      }
      resrow = arow;
    } else {
      if (flag) {
        resrow = arow;
        break;
      }
      if (arow.顺序 == sx) {
        flag = true;
      }
    }
  }
  return resrow;
}


/**
 * 滚动到当前选中行 不管用的话 用tableScrollMove这个
 * jty20200731
 * @param {Object} e               传this即可
 * @param {string} tableFefName    table的ref名称
 */
export function scrollCurRow(e, tableFefName) {
  setTimeout(() => {
    let currow = document.querySelector('.current-row'); //当前选中行
    if(currow==null) return;
    let curTop = currow.getBoundingClientRect().top; //当前选中行top

    let el_head = document.querySelector('.el-table__header'); //标题栏
    let el_window_firstRow_top = el_head.getBoundingClientRect().bottom; //table可见第一行高=是标题栏的bottom

    let el_table = document.querySelector('.el-table'); //表格
    //表格可见区域最后一行top ##50 = 一行高度30 +滚动条20
    let el_window_lastRow_top = document.querySelector('.el-table').getBoundingClientRect().bottom - 50;

    //当选中行不在table可见区域  此if为上面
    if (curTop < el_window_firstRow_top) {
      e.$refs[tableFefName].bodyWrapper.scrollTop = e.$refs[tableFefName].bodyWrapper.scrollTop + curTop -
        el_window_firstRow_top;
    }
    //当选中行不在table可见区域  此if为下面
    if (curTop > el_window_lastRow_top) {
      e.$refs[tableFefName].bodyWrapper.scrollTop = e.$refs[tableFefName].bodyWrapper.scrollTop + curTop -
        el_window_lastRow_top;
    }
  }, 10);

}
/**
 * 上面 scrollCurRow 不管用的时候用这个 滚动条自动滚动到当前选中行
 * @description: 通过表格行索引 定位表格的位置
 * @param {Object} e               传this即可
 * @param {string} refName    table的ref名称
 * @param {integer} index    行的的索引
 * @author 蒋
 */
export function tableScrollMove(e,refName, index = 0) {
  // setTimeout(() => {
    e.$nextTick (() => {
    if (!refName || !e.$refs[refName]) return//不存在表格的ref vm 则返回
    let vmEl = e.$refs[refName].$el
    if (!vmEl) return
    // 计算滚动条的位置
    const targetTop = vmEl.querySelectorAll('.el-table__body tr')[index].getBoundingClientRect().top
    const containerTop = vmEl.querySelector('.el-table__body').getBoundingClientRect().top
    const scrollParent = vmEl.querySelector('.el-table__body-wrapper')
    scrollParent.scrollTop = targetTop - containerTop
  })
};
/**
 * 获取系统参数，返回参数对象，对象属性对应参数表字段。如果未找到参数，返回undefined
 * @param {Object} key  参数关键字
 * @param {Object} leixing 参数关键字类型，参数代码或参数名称，如果不传leixing，默认为参数代码
 */
export function GetXiTongCanShu(key,leixing='参数代码'){
  let canshu=JSON.parse(store.state.XiTongCanShu).filter(val=>val.节点类别==='1');
  //let cs=canshu.filter(val=>val.节点类别==='1');
  //console.log(cs);
  //console.log('系统参数列表：',canshu);
  if(leixing===undefined||leixing===''||leixing==='参数代码')
  {
    return canshu.find(row=>row.参数代码===key);
  }
  else if(leixing==='参数名称'){
    return canshu.find(row=>row.参数名称===key);
  }
  else{
    return undefined;
  }
}
//获取当前登录用户信息
export function GetUserInfo(){
  return JSON.parse(store.state.UserInfo);
}
export function banBackSpace(e){
  var ev = e || window.event;
  //各种浏览器下获取事件对象
  var obj = ev.relatedTarget || ev.srcElement || ev.target ||ev.currentTarget;
  //按下Backspace键
  if(ev.keyCode == 8){
    var tagName = obj.nodeName //标签名称
    //如果标签不是input或者textarea则阻止Backspace
    if(tagName!='INPUT' && tagName!='TEXTAREA'){
      return stopIt(ev);
    }
    var tagType = obj.type.toUpperCase();//标签类型
    //input标签除了下面几种类型，全部阻止Backspace
    if(tagName=='INPUT' && (tagType!='TEXT' && tagType!='TEXTAREA' && tagType!='PASSWORD' && tagType!='NUMBER')){
      return stopIt(ev);
    }
    //input或者textarea输入框如果不可编辑则阻止Backspace
    if((tagName=='INPUT' || tagName=='TEXTAREA') && (obj.readOnly==true || obj.disabled ==true)){
      return stopIt(ev);
    }
  }
}
export function stopIt(ev){
  if(ev.preventDefault ){
    //preventDefault()方法阻止元素发生默认的行为
    ev.preventDefault();
  }
  if(ev.returnValue){
    //IE浏览器下用window.event.returnValue = false;实现阻止元素发生默认的行为
    ev.returnValue = false;
  }
  return false;
}
/**
 *获取当前时间
 *format=1精确到天 2020-09-18
 *format=2精确到秒 2020-09-19 16:46:30
*/
export function getCurrentDate(format=1) {
  var now = new Date();
  var year = now.getFullYear(); //得到年份
  var month = now.getMonth();//得到月份
  var date = now.getDate();//得到日期
  var day = now.getDay();//得到周几
  var hour = now.getHours();//得到小时
  var minu = now.getMinutes();//得到分钟
  var sec = now.getSeconds();//得到秒
  month = month + 1;
  if (month < 10) month = "0" + month;
  if (date < 10) date = "0" + date;
  if (hour < 10) hour = "0" + hour;
  if (minu < 10) minu = "0" + minu;
  if (sec < 10) sec = "0" + sec;
  var time = "";
  //精确到天
  if(format==1){
    time = year + "-" + month + "-" + date;
  }
  //精确到分
  else if(format==2){
    time = year + "-" + month + "-" + date+ " " + hour + ":" + minu + ":" + sec;
  }
  return time;
}
export function locateConfirm(event){
  //console.log(event);
  setTimeout(function(){
    let dom=document.querySelector('.el-message-box');
    if(dom){
      let top='200px';
      let left='100px';

      if(event){
        top=event.clientY + 35 + 'px';
        left=event.clientX - 310 + 'px';
        if(event.clientX<310){
          left='10px';
        }
      }

      dom.style.position='absolute';
      dom.style.top=top;
      dom.style.left=left;
    }
  },50);

}
// 获取经办人dialog的宽度,在打开选择经办人dialog之前调用 this.dialogWidth=getJbrDiaWidth()
export function getJbrDiaWidth() {
  //获取系统参数
  let XtCanShu=GetXiTongCanShu('QJGZ_DanJuJBRSelSource');
  //console.log(XtCanShu);
  let dialogWidth=""
  if(XtCanShu["参数值"]==='0'){
    dialogWidth="315px"
  }else if(XtCanShu["参数值"]==='1'){
    dialogWidth="1100px"
  }
  return dialogWidth
}

/**
 * @function 获取汉字首字母
 * @param {String} data  要获取首字母的汉字
 * @param {boolean} toUpper 是否转为大写字母，默认为false
 */
export function GetPinyinShouzimu(data,toUpper=false) {
  let szm=''; //首字母
  if(data!=undefined||data!=''){
    let a = pinyin(data, {
      style: pinyin.STYLE_FIRST_LETTER
    });
    for(let i=0; i<a.length; i++){
      szm +=a[i];
    }
  }
  if(toUpper){
    szm=szm.toUpperCase();
  }
  return szm;
}

/**
 * @function 检查sql语句中是否有非查询类关键字
 * @param {String} sqlStr  待检查的sql语句
 */
export function CheckSQL(sqlStr) {
  let keyWords=['insert','update','delete','drop','alter','truncate','create', 'select'];  //非查询类操作关键字
  let returnValue=false;
  for(let i=0; i<keyWords.length; i++){
    if(sqlStr.toLowerCase().indexOf(keyWords[i])>=0){
      returnValue=true;
    }
  }
  return returnValue;
}
/**
 * 封装Confirm窗口,返回true或false
 * options:{
		title: '提示',
		customClass: 'customAlertClass650', 预定义类customAlertClass500至customAlertClass900，间隔50取值
		type: 'warning',
		cancelButtonClass: 'btn-custom-cancel',
		confirmButtonText: '是',
		cancelButtonText: '否',
		dangerouslyUseHTMLString: true,
		showClose: false,
	}
	调用：
	let flag=await util.Confirm('是否继续');
 */
export async function Confirm(message, options={}){
	let title=options.title||'提示';								//MessageBox 标题
	let customClass=options.customClass||'';				//MessageBox 的自定义类名，如改变窗口宽度
	let type=options.type||'warning';							//消息类型，success / info / warning / error
	let cancelButtonClass=options.cancelButtonClass||'btn-custom-cancel';		//取消按钮的自定义类名
	let confirmButtonText=options.confirmButtonText||'是';			//确定按钮的文本内容
	let cancelButtonText=options.cancelButtonText||'否';				//取消按钮的文本内容
	let dangerouslyUseHTMLString=options.dangerouslyUseHTMLString||true;		//是否将 message 属性作为 HTML 片段处理
	let showClose=options.showClose||false;	//是否显示右上角关闭按钮
	
	if(!message){
		message='是否继续？';
	}
	
	return new Promise((resolve, rejects) => {
		MessageBox.confirm(message, title, {
				cancelButtonClass: cancelButtonClass, //自定义样式
				confirmButtonText: confirmButtonText,
				cancelButtonText: cancelButtonText,
				type: type,
				customClass: customClass,
				dangerouslyUseHTMLString: dangerouslyUseHTMLString,
				showClose: showClose,
			})
			.then(() => {
				resolve(true);
			})
			.catch(() => {
				resolve(false);
			});
	});
}
/**
 * 封装Alert窗口，弹出确定窗口
 * options:{
		title: '系统提示',
		customClass: 'customAlertClass650', 预定义类customAlertClass500至customAlertClass900，间隔50取值
		type: 'warning',
		confirmButtonText: '确定',
		dangerouslyUseHTMLString: true,
		callback: (action)=>{}	//回调函数
	}
	调用：
	util.Alert('系统警告');
 */
export function Alert(message, options={}){
	let title=options.title||'系统提示';								//MessageBox 标题
	let customClass=options.customClass||'';				//MessageBox 的自定义类名，如改变窗口宽度
	let type=options.type||'warning';							//消息类型，success / info / warning / error
	let confirmButtonText=options.confirmButtonText||'确定';			//确定按钮的文本内容
	let dangerouslyUseHTMLString=options.dangerouslyUseHTMLString||true;		//是否将 message 属性作为 HTML 片段处理
	let callback=options.callback||function(action){};
	
	if(!message){
		message='警告！';
	}
	
	MessageBox.alert(message, title, {
		type: type,
		confirmButtonText: confirmButtonText,
		dangerouslyUseHTMLString: dangerouslyUseHTMLString,
		customClass: customClass,
		callback: callback,
	});
}
/**
 * 返回两个日期之间的差
 * @param {Object} StartDate
 * @param {Object} EndDate
 * @param {Object} type  //返回值类型：yy 年，mm 月，dd 日，hh 小时，MM 分钟，ss  秒
 */
export function DateDiff(StartDate, EndDate, type = "dd") {
	let start = StartDate;
	if(getObjectType(StartDate)=='String'){
		start = new Date(StartDate);
	}
	let end = EndDate;
	if(getObjectType(EndDate)=='String'){
		end = new Date(EndDate);
	}
	
	let returnValue = 0;

	returnValue = end - start;
	//console.log("returnValue", StartDate, end, returnValue);

	if (type == "ss") {
		returnValue = returnValue / 1000;
	} else if (type == "MM") {
		returnValue = parseInt(returnValue / 1000 / 60);
	} else if (type == "hh") {
		returnValue = parseFloat(returnValue / 1000 / 60 / 60);
	} else if (type == "TB") {
		//台班
		returnValue = parseFloat(returnValue / 1000 / 60 / 60 / 8);
	} else if (type == "dd") {//精确到天，不考虑时间，只判断日期
		let startYear = start.getFullYear();
		let startMonth = start.getMonth() + 1;
		let endYear = end.getFullYear();
		let endMonth = end.getMonth() + 1;
		let startDay = start.getDate();
		let endDay = end.getDate();
		
		let StartDateStr = startYear + '-' + startMonth + '-' + startDay;	// 去掉时间
		let EndDateStr = endYear + '-' + endMonth + '-' + endDay;	// 去掉时间
		
		start = new Date(StartDateStr);
		end = new Date(EndDateStr);

		returnValue = end - start;
		
		returnValue = parseInt(returnValue / 1000 / 60 / 60 / 24);
	} else if (type == "mm") {
		let startYear = start.getFullYear();
		let startMonth = start.getMonth() + 1;
		let endYear = end.getFullYear();
		let endMonth = end.getMonth() + 1;
		let startDay = start.getDate();
		let endDay = end.getDate();

		returnValue = (endYear - startYear) * 12 + endMonth - startMonth;

		if (startDay > endDay && endMonth > startMonth) {
			returnValue = returnValue - 1;
		}
	} else if (type == "yy") {
		let startYear = start.getFullYear();
		let endYear = end.getFullYear();
		let startMonth = start.getMonth() + 1;
		let endMonth = end.getMonth() + 1;

		returnValue = endYear - startYear;

		if (startMonth > endMonth && endYear > startYear) {
			returnValue = returnValue - 1;
		}
	}
	return returnValue;
}
export function getObjectType(obj) {
	let valType = Object.prototype.toString.call(obj);

	let t = valType.split(" ");

	if (t.length > 1) {
		let t2 = t[1];
		let type = t2.replace("]", "");

		return type;
	}
}
export function dateFormat(fmt, date) {
	if(getObjectType(date)=='String'){
		date=new Date(date);
	}
	let ret;
	const opt = {
		"y+": date.getFullYear().toString(), // 年
		"M+": (date.getMonth() + 1).toString(), // 月
		"d+": date.getDate().toString(), // 日
		"H+": date.getHours().toString(), // 时
		"m+": date.getMinutes().toString(), // 分
		"s+": date.getSeconds().toString(), // 秒
		// 有其他格式化字符需求可以继续添加，必须转化成字符串
	};
	for (let k in opt) {
		ret = new RegExp("(" + k + ")").exec(fmt);
		if (ret) {
			fmt = fmt.replace(
				ret[1],
				ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
			);
		}
	}
	return fmt;
}

export function CreateUUID() {
  let s = [];
  let hexDigits = "0123456789abcdef";
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  let uuid = s.join("");
  return uuid;
}